import { FunctionComponent } from "react";

export interface NoProps {}
 
const NotFoundPage: FunctionComponent<NoProps> = () =>  <div className="notFound">Page not Found</div>
 
export default NotFoundPage;